import Storyblok from "storyblok-js-client"

export const getStoryblokClient = () => {
    const storyblok = new Storyblok({
        accessToken: process.env.GATSBY_STORYBLOK_API_KEY || ''
    })

    return storyblok;
}
